import { render, staticRenderFns } from "./watch-intro.vue?vue&type=template&id=8961e11c&scoped=true"
import script from "./watch-intro.vue?vue&type=script&lang=js"
export * from "./watch-intro.vue?vue&type=script&lang=js"
import style0 from "./watch-intro.vue?vue&type=style&index=0&id=8961e11c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8961e11c",
  null
  
)

export default component.exports